import React, { useEffect, useState } from 'react';
import './ScrollArrow.css';

function ScrollArrow({ timeout=10000 }){

  const [arrowDisplay, setArrowDisplay] = useState(true);

  useEffect( 
    () => {
      setTimeout(
        () => { setArrowDisplay(false); }, timeout);
    },[timeout]);

  return(
    <div className={`arrowBox ${ arrowDisplay ? 'shown' : ''}`}>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );

}


export default ScrollArrow;